import Fe, { useState as Le, useRef as ot, useEffect as qe } from "react";
var or = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function dn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function pn(e) {
  if (e.__esModule) return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), t;
}
var hr = { exports: {} }, $e = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function yn() {
  if (Wr) return $e;
  Wr = 1;
  var e = Fe, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(u, d, b) {
    var p, _ = {}, j = null, C = null;
    b !== void 0 && (j = "" + b), d.key !== void 0 && (j = "" + d.key), d.ref !== void 0 && (C = d.ref);
    for (p in d) n.call(d, p) && !i.hasOwnProperty(p) && (_[p] = d[p]);
    if (u && u.defaultProps) for (p in d = u.defaultProps, d) _[p] === void 0 && (_[p] = d[p]);
    return { $$typeof: r, type: u, key: j, ref: C, props: _, _owner: o.current };
  }
  return $e.Fragment = t, $e.jsx = f, $e.jsxs = f, $e;
}
var Ie = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hr;
function hn() {
  return Hr || (Hr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Fe, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), u = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), U = Symbol.iterator, I = "@@iterator";
    function H(a) {
      if (a === null || typeof a != "object")
        return null;
      var l = U && a[U] || a[I];
      return typeof l == "function" ? l : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function W(a) {
      {
        for (var l = arguments.length, h = new Array(l > 1 ? l - 1 : 0), g = 1; g < l; g++)
          h[g - 1] = arguments[g];
        V("error", a, h);
      }
    }
    function V(a, l, h) {
      {
        var g = F.ReactDebugCurrentFrame, N = g.getStackAddendum();
        N !== "" && (l += "%s", h = h.concat([N]));
        var L = h.map(function(M) {
          return String(M);
        });
        L.unshift("Warning: " + l), Function.prototype.apply.call(console[a], console, L);
      }
    }
    var q = !1, v = !1, de = !1, xe = !1, je = !1, me;
    me = Symbol.for("react.module.reference");
    function Ce(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === i || je || a === o || a === b || a === p || xe || a === C || q || v || de || typeof a == "object" && a !== null && (a.$$typeof === j || a.$$typeof === _ || a.$$typeof === f || a.$$typeof === u || a.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === me || a.getModuleId !== void 0));
    }
    function be(a, l, h) {
      var g = a.displayName;
      if (g)
        return g;
      var N = l.displayName || l.name || "";
      return N !== "" ? h + "(" + N + ")" : h;
    }
    function _e(a) {
      return a.displayName || "Context";
    }
    function ne(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && W("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case b:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case u:
            var l = a;
            return _e(l) + ".Consumer";
          case f:
            var h = a;
            return _e(h._context) + ".Provider";
          case d:
            return be(a, a.render, "ForwardRef");
          case _:
            var g = a.displayName || null;
            return g !== null ? g : ne(a.type) || "Memo";
          case j: {
            var N = a, L = N._payload, M = N._init;
            try {
              return ne(M(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ae = Object.assign, pe = 0, se, fe, ye, ge, c, m, T;
    function E() {
    }
    E.__reactDisabledLog = !0;
    function w() {
      {
        if (pe === 0) {
          se = console.log, fe = console.info, ye = console.warn, ge = console.error, c = console.group, m = console.groupCollapsed, T = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: E,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        pe++;
      }
    }
    function A() {
      {
        if (pe--, pe === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ae({}, a, {
              value: se
            }),
            info: ae({}, a, {
              value: fe
            }),
            warn: ae({}, a, {
              value: ye
            }),
            error: ae({}, a, {
              value: ge
            }),
            group: ae({}, a, {
              value: c
            }),
            groupCollapsed: ae({}, a, {
              value: m
            }),
            groupEnd: ae({}, a, {
              value: T
            })
          });
        }
        pe < 0 && W("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var P = F.ReactCurrentDispatcher, O;
    function S(a, l, h) {
      {
        if (O === void 0)
          try {
            throw Error();
          } catch (N) {
            var g = N.stack.trim().match(/\n( *(at )?)/);
            O = g && g[1] || "";
          }
        return `
` + O + a;
      }
    }
    var $ = !1, R;
    {
      var G = typeof WeakMap == "function" ? WeakMap : Map;
      R = new G();
    }
    function y(a, l) {
      if (!a || $)
        return "";
      {
        var h = R.get(a);
        if (h !== void 0)
          return h;
      }
      var g;
      $ = !0;
      var N = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = P.current, P.current = null, w();
      try {
        if (l) {
          var M = function() {
            throw Error();
          };
          if (Object.defineProperty(M.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(M, []);
            } catch (oe) {
              g = oe;
            }
            Reflect.construct(a, [], M);
          } else {
            try {
              M.call();
            } catch (oe) {
              g = oe;
            }
            a.call(M.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            g = oe;
          }
          a();
        }
      } catch (oe) {
        if (oe && g && typeof oe.stack == "string") {
          for (var x = oe.stack.split(`
`), ee = g.stack.split(`
`), Y = x.length - 1, K = ee.length - 1; Y >= 1 && K >= 0 && x[Y] !== ee[K]; )
            K--;
          for (; Y >= 1 && K >= 0; Y--, K--)
            if (x[Y] !== ee[K]) {
              if (Y !== 1 || K !== 1)
                do
                  if (Y--, K--, K < 0 || x[Y] !== ee[K]) {
                    var ue = `
` + x[Y].replace(" at new ", " at ");
                    return a.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", a.displayName)), typeof a == "function" && R.set(a, ue), ue;
                  }
                while (Y >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        $ = !1, P.current = L, A(), Error.prepareStackTrace = N;
      }
      var Oe = a ? a.displayName || a.name : "", ve = Oe ? S(Oe) : "";
      return typeof a == "function" && R.set(a, ve), ve;
    }
    function ce(a, l, h) {
      return y(a, !1);
    }
    function we(a) {
      var l = a.prototype;
      return !!(l && l.isReactComponent);
    }
    function he(a, l, h) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return y(a, we(a));
      if (typeof a == "string")
        return S(a);
      switch (a) {
        case b:
          return S("Suspense");
        case p:
          return S("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case d:
            return ce(a.render);
          case _:
            return he(a.type, l, h);
          case j: {
            var g = a, N = g._payload, L = g._init;
            try {
              return he(L(N), l, h);
            } catch {
            }
          }
        }
      return "";
    }
    var Ae = Object.prototype.hasOwnProperty, xr = {}, jr = F.ReactDebugCurrentFrame;
    function Ye(a) {
      if (a) {
        var l = a._owner, h = he(a.type, a._source, l ? l.type : null);
        jr.setExtraStackFrame(h);
      } else
        jr.setExtraStackFrame(null);
    }
    function Vt(a, l, h, g, N) {
      {
        var L = Function.call.bind(Ae);
        for (var M in a)
          if (L(a, M)) {
            var x = void 0;
            try {
              if (typeof a[M] != "function") {
                var ee = Error((g || "React class") + ": " + h + " type `" + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[M] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              x = a[M](l, M, g, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Y) {
              x = Y;
            }
            x && !(x instanceof Error) && (Ye(N), W("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", h, M, typeof x), Ye(null)), x instanceof Error && !(x.message in xr) && (xr[x.message] = !0, Ye(N), W("Failed %s type: %s", h, x.message), Ye(null));
          }
      }
    }
    var Yt = Array.isArray;
    function Qe(a) {
      return Yt(a);
    }
    function zt(a) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, h = l && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return h;
      }
    }
    function Bt(a) {
      try {
        return Cr(a), !1;
      } catch {
        return !0;
      }
    }
    function Cr(a) {
      return "" + a;
    }
    function Ar(a) {
      if (Bt(a))
        return W("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zt(a)), Cr(a);
    }
    var Me = F.ReactCurrentOwner, qt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Mr, $r, er;
    er = {};
    function Kt(a) {
      if (Ae.call(a, "ref")) {
        var l = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function Zt(a) {
      if (Ae.call(a, "key")) {
        var l = Object.getOwnPropertyDescriptor(a, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function Xt(a, l) {
      if (typeof a.ref == "string" && Me.current && l && Me.current.stateNode !== l) {
        var h = ne(Me.current.type);
        er[h] || (W('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ne(Me.current.type), a.ref), er[h] = !0);
      }
    }
    function Jt(a, l) {
      {
        var h = function() {
          Mr || (Mr = !0, W("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        h.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: h,
          configurable: !0
        });
      }
    }
    function Gt(a, l) {
      {
        var h = function() {
          $r || ($r = !0, W("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        h.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: h,
          configurable: !0
        });
      }
    }
    var Qt = function(a, l, h, g, N, L, M) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: a,
        key: l,
        ref: h,
        props: M,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function en(a, l, h, g, N) {
      {
        var L, M = {}, x = null, ee = null;
        h !== void 0 && (Ar(h), x = "" + h), Zt(l) && (Ar(l.key), x = "" + l.key), Kt(l) && (ee = l.ref, Xt(l, N));
        for (L in l)
          Ae.call(l, L) && !qt.hasOwnProperty(L) && (M[L] = l[L]);
        if (a && a.defaultProps) {
          var Y = a.defaultProps;
          for (L in Y)
            M[L] === void 0 && (M[L] = Y[L]);
        }
        if (x || ee) {
          var K = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          x && Jt(M, K), ee && Gt(M, K);
        }
        return Qt(a, x, ee, N, g, Me.current, M);
      }
    }
    var rr = F.ReactCurrentOwner, Ir = F.ReactDebugCurrentFrame;
    function Pe(a) {
      if (a) {
        var l = a._owner, h = he(a.type, a._source, l ? l.type : null);
        Ir.setExtraStackFrame(h);
      } else
        Ir.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function nr(a) {
      return typeof a == "object" && a !== null && a.$$typeof === r;
    }
    function Nr() {
      {
        if (rr.current) {
          var a = ne(rr.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function rn(a) {
      return "";
    }
    var kr = {};
    function tn(a) {
      {
        var l = Nr();
        if (!l) {
          var h = typeof a == "string" ? a : a.displayName || a.name;
          h && (l = `

Check the top-level render call using <` + h + ">.");
        }
        return l;
      }
    }
    function Dr(a, l) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var h = tn(l);
        if (kr[h])
          return;
        kr[h] = !0;
        var g = "";
        a && a._owner && a._owner !== rr.current && (g = " It was passed a child from " + ne(a._owner.type) + "."), Pe(a), W('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', h, g), Pe(null);
      }
    }
    function Lr(a, l) {
      {
        if (typeof a != "object")
          return;
        if (Qe(a))
          for (var h = 0; h < a.length; h++) {
            var g = a[h];
            nr(g) && Dr(g, l);
          }
        else if (nr(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var N = H(a);
          if (typeof N == "function" && N !== a.entries)
            for (var L = N.call(a), M; !(M = L.next()).done; )
              nr(M.value) && Dr(M.value, l);
        }
      }
    }
    function nn(a) {
      {
        var l = a.type;
        if (l == null || typeof l == "string")
          return;
        var h;
        if (typeof l == "function")
          h = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === _))
          h = l.propTypes;
        else
          return;
        if (h) {
          var g = ne(l);
          Vt(h, a.props, "prop", g, a);
        } else if (l.PropTypes !== void 0 && !tr) {
          tr = !0;
          var N = ne(l);
          W("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", N || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && W("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function an(a) {
      {
        for (var l = Object.keys(a.props), h = 0; h < l.length; h++) {
          var g = l[h];
          if (g !== "children" && g !== "key") {
            Pe(a), W("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Pe(null);
            break;
          }
        }
        a.ref !== null && (Pe(a), W("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Ur = {};
    function Fr(a, l, h, g, N, L) {
      {
        var M = Ce(a);
        if (!M) {
          var x = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = rn();
          ee ? x += ee : x += Nr();
          var Y;
          a === null ? Y = "null" : Qe(a) ? Y = "array" : a !== void 0 && a.$$typeof === r ? (Y = "<" + (ne(a.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : Y = typeof a, W("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Y, x);
        }
        var K = en(a, l, h, N, L);
        if (K == null)
          return K;
        if (M) {
          var ue = l.children;
          if (ue !== void 0)
            if (g)
              if (Qe(ue)) {
                for (var Oe = 0; Oe < ue.length; Oe++)
                  Lr(ue[Oe], a);
                Object.freeze && Object.freeze(ue);
              } else
                W("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Lr(ue, a);
        }
        if (Ae.call(l, "key")) {
          var ve = ne(a), oe = Object.keys(l).filter(function(fn) {
            return fn !== "key";
          }), ar = oe.length > 0 ? "{key: someKey, " + oe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ur[ve + ar]) {
            var un = oe.length > 0 ? "{" + oe.join(": ..., ") + ": ...}" : "{}";
            W(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ar, ve, un, ve), Ur[ve + ar] = !0;
          }
        }
        return a === n ? an(K) : nn(K), K;
      }
    }
    function on(a, l, h) {
      return Fr(a, l, h, !0);
    }
    function sn(a, l, h) {
      return Fr(a, l, h, !1);
    }
    var ln = sn, cn = on;
    Ie.Fragment = n, Ie.jsx = ln, Ie.jsxs = cn;
  }()), Ie;
}
process.env.NODE_ENV === "production" ? hr.exports = yn() : hr.exports = hn();
var s = hr.exports;
const Fo = ({
  label: e = "",
  size: r = "medium",
  style: t = "primary",
  state: n = "default",
  iconLeft: o = !1,
  iconType: i = "arrow",
  href: f,
  onClick: u,
  ...d
}) => {
  const b = r ? ` wb-btn--${r} ` : "", p = t ? ` wb-btn--${t} ` : "", _ = n ? ` wb-btn--${n} ` : "", j = f ? "a" : "button", C = e || i, U = o ? "wb-btn--reverse" : "", I = () => t === "green" ? "check" : t === "red" ? "delete" : i ? i === "arrow" ? "arrow_forward" : i : void 0, H = (V) => V.startsWith("http") || V.startsWith("//");
  let F = {};
  f && H(f) && (F = {
    target: "_blank",
    rel: "noopener noreferrer"
  });
  const W = I();
  return /* @__PURE__ */ s.jsxs(
    j,
    {
      className: `wb-btn ${b} ${p} ${_} ${U}`,
      disabled: n == "disabled",
      href: n !== "disabled" ? f : void 0,
      onClick: n !== "disabled" ? u : void 0,
      "aria-label": C,
      "aria-disabled": n === "disabled",
      role: f ? "button" : void 0,
      tabIndex: n === "disabled" ? -1 : 0,
      ...d,
      ...F,
      children: [
        e && e,
        W && /* @__PURE__ */ s.jsx("span", { className: "material-icons wb-btn--icon", role: "img", "aria-hidden": "true", children: W })
      ]
    }
  );
}, vn = ({ href: e, arialabel: r, children: t, ...n }) => {
  const i = ((f) => f.startsWith("http") || f.startsWith("//"))(e) ? "_blank" : void 0;
  return /* @__PURE__ */ s.jsx(
    "a",
    {
      href: e,
      target: i,
      className: n.className,
      "aria-label": r,
      rel: i ? "noopener noreferrer" : void 0,
      ...n,
      children: t
    }
  );
}, Wo = ({
  cardType: e = "default",
  className: r = "",
  bgcolor: t = "",
  img: n = "",
  imgAlt: o = "",
  imgHoverColor: i = !1,
  date: f,
  categories: u,
  cardtitle: d = "",
  description: b = "",
  children: p = /* @__PURE__ */ s.jsx(s.Fragment, {}),
  link: _
}) => {
  const j = /* @__PURE__ */ s.jsx("picture", { className: "wb-card__image", children: /* @__PURE__ */ s.jsx("img", { src: n, alt: o, "aria-label": o }) }), C = () => e === "basic" ? "transparant" : t || "white";
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: "wb-card " + r + " wb-card--" + e + " " + C(),
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "wb-card__content", children: [
          (d || b) && /* @__PURE__ */ s.jsxs("div", { className: "wb-card__body", children: [
            d && /* @__PURE__ */ s.jsx("h3", { className: "wb-card__title", children: d }),
            b && /* @__PURE__ */ s.jsx("p", { className: "wb-card__description", children: b })
          ] }),
          (f || u) && /* @__PURE__ */ s.jsxs("div", { className: "wb-card__meta", children: [
            f && /* @__PURE__ */ s.jsx("span", { className: "wb-card__date", children: f }),
            u && u.length > 0 && /* @__PURE__ */ s.jsx("div", { className: "wb-card__categories", children: u.map((U, I) => /* @__PURE__ */ s.jsxs("span", { className: "wb-card__category", children: [
              U.icon && /* @__PURE__ */ s.jsx("span", { className: "category-icon material-icons", children: U.icon }),
              U.label && U.label
            ] }, I)) })
          ] })
        ] }),
        n && /* @__PURE__ */ s.jsx("div", { className: "wb-card__image-container", "data-bgcolor": i, children: j }),
        (p || _) && e !== "basic" && /* @__PURE__ */ s.jsxs("div", { className: "wb-card__footer ", children: [
          p,
          _ && /* @__PURE__ */ s.jsx("span", { className: "wb-card__linkicon", children: /* @__PURE__ */ s.jsx("span", { className: "material-icons", children: "arrow_forward" }) })
        ] }),
        _ && /* @__PURE__ */ s.jsx(vn, { href: _, arialabel: d || _, className: "wb-card__link--stretched", children: " " })
      ]
    }
  );
}, Ho = ({
  collapsed: e = !0,
  question: r,
  answer: t,
  className: n = "",
  children: o = /* @__PURE__ */ s.jsx(s.Fragment, {})
}) => /* @__PURE__ */ s.jsx("div", { className: "wb-container", children: /* @__PURE__ */ s.jsxs("details", { className: `wb-collapsible ${n}`, open: !e, children: [
  /* @__PURE__ */ s.jsx("summary", { children: /* @__PURE__ */ s.jsx("div", { className: "wb-collapsible__question", children: r }) }),
  /* @__PURE__ */ s.jsxs("div", { className: "wb-collapsible__content", children: [
    t && /* @__PURE__ */ s.jsx("div", { dangerouslySetInnerHTML: { __html: t } }),
    o
  ] })
] }) }), Vo = ({
  children: e = /* @__PURE__ */ s.jsx(s.Fragment, {}),
  decline: r = /* @__PURE__ */ s.jsx(s.Fragment, {}),
  approve: t = /* @__PURE__ */ s.jsx(s.Fragment, {})
}) => /* @__PURE__ */ s.jsxs("div", { className: "wb-cookiebar", children: [
  e && /* @__PURE__ */ s.jsx("div", { className: "wb-cookiebar__inner", children: " children" }),
  r && r,
  t && t
] }), Yo = ({
  company: e = "",
  children: r = /* @__PURE__ */ s.jsx(s.Fragment, {})
}) => {
  function t() {
    return (/* @__PURE__ */ new Date()).getFullYear();
  }
  return /* @__PURE__ */ s.jsxs("footer", { className: "wb-footer", children: [
    /* @__PURE__ */ s.jsxs("span", { children: [
      t(),
      " ©",
      " ",
      /* @__PURE__ */ s.jsx("span", { dangerouslySetInnerHTML: { __html: e } })
    ] }),
    r
  ] });
}, zo = ({
  logo: e,
  sticky: r = !1,
  skiplink: t,
  apptitle: n,
  children: o
}) => {
  const [i, f] = Le(!1), u = ot(null), d = n || "";
  return qe(() => {
    const b = (p) => {
      i && u.current && !u.current.contains(p.target) && f(!1);
    };
    return document.addEventListener("focusin", b), () => {
      document.removeEventListener("focusin", b);
    };
  }, [i]), /* @__PURE__ */ s.jsxs(
    "header",
    {
      className: "wb-header",
      ref: u,
      "data-sticky": r,
      "data-open": i,
      onKeyDown: (b) => {
        b.key === "Escape" && i && f(!1);
      },
      tabIndex: 0,
      children: [
        t && /* @__PURE__ */ s.jsx("div", { className: "wb-header__skiplink", children: t }),
        e && /* @__PURE__ */ s.jsx("div", { className: "wb-header__logo", children: e }),
        /* @__PURE__ */ s.jsx("span", { className: "wb-header__title", children: d }),
        /* @__PURE__ */ s.jsx("div", { className: "wb-header__togglemenu", children: /* @__PURE__ */ s.jsx(
          "button",
          {
            onClick: () => f(!i),
            className: "wb-header__toggler",
            type: "button",
            "aria-expanded": i,
            "aria-label": "Toggle menu",
            children: "Menu"
          }
        ) }),
        /* @__PURE__ */ s.jsx("div", { className: "wb-header__toggle", children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: "wb-header__menus",
            onClick: (b) => {
              var p;
              b.target.tagName === "A" && (f(!1), (p = document.activeElement) == null || p.blur());
            },
            children: o
          }
        ) })
      ]
    }
  );
};
var mn = function(r, t, n) {
  var o = document.head || document.getElementsByTagName("head")[0], i = document.createElement("script");
  typeof t == "function" && (n = t, t = {}), t = t || {}, n = n || function() {
  }, i.type = t.type || "text/javascript", i.charset = t.charset || "utf8", i.async = "async" in t ? !!t.async : !0, i.src = r, t.attrs && bn(i, t.attrs), t.text && (i.text = "" + t.text);
  var f = "onload" in i ? Vr : _n;
  f(i, n), i.onload || Vr(i, n), o.appendChild(i);
};
function bn(e, r) {
  for (var t in r)
    e.setAttribute(t, r[t]);
}
function Vr(e, r) {
  e.onload = function() {
    this.onerror = this.onload = null, r(null, e);
  }, e.onerror = function() {
    this.onerror = this.onload = null, r(new Error("Failed to load " + this.src), e);
  };
}
function _n(e, r) {
  e.onreadystatechange = function() {
    this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, r(null, e));
  };
}
var gn = function(r) {
  return wn(r) && !Pn(r);
};
function wn(e) {
  return !!e && typeof e == "object";
}
function Pn(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || Tn(e);
}
var On = typeof Symbol == "function" && Symbol.for, En = On ? Symbol.for("react.element") : 60103;
function Tn(e) {
  return e.$$typeof === En;
}
function Sn(e) {
  return Array.isArray(e) ? [] : {};
}
function Ue(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? Re(Sn(e), e, r) : e;
}
function Rn(e, r, t) {
  return e.concat(r).map(function(n) {
    return Ue(n, t);
  });
}
function xn(e, r) {
  if (!r.customMerge)
    return Re;
  var t = r.customMerge(e);
  return typeof t == "function" ? t : Re;
}
function jn(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(r) {
    return Object.propertyIsEnumerable.call(e, r);
  }) : [];
}
function Yr(e) {
  return Object.keys(e).concat(jn(e));
}
function it(e, r) {
  try {
    return r in e;
  } catch {
    return !1;
  }
}
function Cn(e, r) {
  return it(e, r) && !(Object.hasOwnProperty.call(e, r) && Object.propertyIsEnumerable.call(e, r));
}
function An(e, r, t) {
  var n = {};
  return t.isMergeableObject(e) && Yr(e).forEach(function(o) {
    n[o] = Ue(e[o], t);
  }), Yr(r).forEach(function(o) {
    Cn(e, o) || (it(e, o) && t.isMergeableObject(r[o]) ? n[o] = xn(o, t)(e[o], r[o], t) : n[o] = Ue(r[o], t));
  }), n;
}
function Re(e, r, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || Rn, t.isMergeableObject = t.isMergeableObject || gn, t.cloneUnlessOtherwiseSpecified = Ue;
  var n = Array.isArray(r), o = Array.isArray(e), i = n === o;
  return i ? n ? t.arrayMerge(e, r, t) : An(e, r, t) : Ue(r, t);
}
Re.all = function(r, t) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(n, o) {
    return Re(n, o, t);
  }, {});
};
var Mn = Re, st = Mn, $n = Object.create, Ke = Object.defineProperty, In = Object.getOwnPropertyDescriptor, Nn = Object.getOwnPropertyNames, kn = Object.getPrototypeOf, Dn = Object.prototype.hasOwnProperty, Ln = (e, r) => {
  for (var t in r)
    Ke(e, t, { get: r[t], enumerable: !0 });
}, lt = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of Nn(r))
      !Dn.call(e, o) && o !== t && Ke(e, o, { get: () => r[o], enumerable: !(n = In(r, o)) || n.enumerable });
  return e;
}, wr = (e, r, t) => (t = e != null ? $n(kn(e)) : {}, lt(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? Ke(t, "default", { value: e, enumerable: !0 }) : t,
  e
)), Un = (e) => lt(Ke({}, "__esModule", { value: !0 }), e), ct = {};
Ln(ct, {
  callPlayer: () => ra,
  getConfig: () => Qn,
  getSDK: () => Gn,
  isBlobUrl: () => na,
  isMediaStream: () => ta,
  lazy: () => Vn,
  omit: () => ea,
  parseEndTime: () => Zn,
  parseStartTime: () => Kn,
  queryString: () => Jn,
  randomString: () => Xn,
  supportsWebKitPresentationMode: () => aa
});
var Ze = Un(ct), Fn = wr(Fe), Wn = wr(mn), Hn = wr(st);
const Vn = (e) => Fn.default.lazy(async () => {
  const r = await e();
  return typeof r.default == "function" ? r : r.default;
}), Yn = /[?&#](?:start|t)=([0-9hms]+)/, zn = /[?&#]end=([0-9hms]+)/, vr = /(\d+)(h|m|s)/g, Bn = /^\d+$/;
function ut(e, r) {
  if (e instanceof Array)
    return;
  const t = e.match(r);
  if (t) {
    const n = t[1];
    if (n.match(vr))
      return qn(n);
    if (Bn.test(n))
      return parseInt(n);
  }
}
function qn(e) {
  let r = 0, t = vr.exec(e);
  for (; t !== null; ) {
    const [, n, o] = t;
    o === "h" && (r += parseInt(n, 10) * 60 * 60), o === "m" && (r += parseInt(n, 10) * 60), o === "s" && (r += parseInt(n, 10)), t = vr.exec(e);
  }
  return r;
}
function Kn(e) {
  return ut(e, Yn);
}
function Zn(e) {
  return ut(e, zn);
}
function Xn() {
  return Math.random().toString(36).substr(2, 5);
}
function Jn(e) {
  return Object.keys(e).map((r) => `${r}=${e[r]}`).join("&");
}
function ir(e) {
  return window[e] ? window[e] : window.exports && window.exports[e] ? window.exports[e] : window.module && window.module.exports && window.module.exports[e] ? window.module.exports[e] : null;
}
const Ee = {}, Gn = function(r, t, n = null, o = () => !0, i = Wn.default) {
  const f = ir(t);
  return f && o(f) ? Promise.resolve(f) : new Promise((u, d) => {
    if (Ee[r]) {
      Ee[r].push({ resolve: u, reject: d });
      return;
    }
    Ee[r] = [{ resolve: u, reject: d }];
    const b = (p) => {
      Ee[r].forEach((_) => _.resolve(p));
    };
    if (n) {
      const p = window[n];
      window[n] = function() {
        p && p(), b(ir(t));
      };
    }
    i(r, (p) => {
      p ? (Ee[r].forEach((_) => _.reject(p)), Ee[r] = null) : n || b(ir(t));
    });
  });
};
function Qn(e, r) {
  return (0, Hn.default)(r.config, e.config);
}
function ea(e, ...r) {
  const t = [].concat(...r), n = {}, o = Object.keys(e);
  for (const i of o)
    t.indexOf(i) === -1 && (n[i] = e[i]);
  return n;
}
function ra(e, ...r) {
  if (!this.player || !this.player[e]) {
    let t = `ReactPlayer: ${this.constructor.displayName} player could not call %c${e}%c – `;
    return this.player ? this.player[e] || (t += "The method was not available") : t += "The player was not available", console.warn(t, "font-weight: bold", ""), null;
  }
  return this.player[e](...r);
}
function ta(e) {
  return typeof window < "u" && typeof window.MediaStream < "u" && e instanceof window.MediaStream;
}
function na(e) {
  return /^blob:/.test(e);
}
function aa(e = document.createElement("video")) {
  const r = /iPhone|iPod/.test(navigator.userAgent) === !1;
  return e.webkitSupportsPresentationMode && typeof e.webkitSetPresentationMode == "function" && r;
}
var Pr = Object.defineProperty, oa = Object.getOwnPropertyDescriptor, ia = Object.getOwnPropertyNames, sa = Object.prototype.hasOwnProperty, la = (e, r) => {
  for (var t in r)
    Pr(e, t, { get: r[t], enumerable: !0 });
}, ca = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of ia(r))
      !sa.call(e, o) && o !== t && Pr(e, o, { get: () => r[o], enumerable: !(n = oa(r, o)) || n.enumerable });
  return e;
}, ua = (e) => ca(Pr({}, "__esModule", { value: !0 }), e), ft = {};
la(ft, {
  AUDIO_EXTENSIONS: () => Or,
  DASH_EXTENSIONS: () => Tt,
  FLV_EXTENSIONS: () => St,
  HLS_EXTENSIONS: () => Tr,
  MATCH_URL_DAILYMOTION: () => wt,
  MATCH_URL_FACEBOOK: () => ht,
  MATCH_URL_FACEBOOK_WATCH: () => vt,
  MATCH_URL_KALTURA: () => Et,
  MATCH_URL_MIXCLOUD: () => Pt,
  MATCH_URL_MUX: () => yt,
  MATCH_URL_SOUNDCLOUD: () => dt,
  MATCH_URL_STREAMABLE: () => mt,
  MATCH_URL_TWITCH_CHANNEL: () => gt,
  MATCH_URL_TWITCH_VIDEO: () => _t,
  MATCH_URL_VIDYARD: () => Ot,
  MATCH_URL_VIMEO: () => pt,
  MATCH_URL_WISTIA: () => bt,
  MATCH_URL_YOUTUBE: () => mr,
  VIDEO_EXTENSIONS: () => Er,
  canPlay: () => da
});
var fa = ua(ft), zr = Ze;
const mr = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, dt = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, pt = /vimeo\.com\/(?!progressive_redirect).+/, yt = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, ht = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, vt = /^https?:\/\/fb\.watch\/.+$/, mt = /streamable\.com\/([a-z0-9]+)$/, bt = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, _t = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, gt = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, wt = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, Pt = /mixcloud\.com\/([^/]+\/[^/]+)/, Ot = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, Et = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, Or = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, Er = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, Tr = /\.(m3u8)($|\?)/i, Tt = /\.(mpd)($|\?)/i, St = /\.(flv)($|\?)/i, br = (e) => {
  if (e instanceof Array) {
    for (const r of e)
      if (typeof r == "string" && br(r) || br(r.src))
        return !0;
    return !1;
  }
  return (0, zr.isMediaStream)(e) || (0, zr.isBlobUrl)(e) ? !0 : Or.test(e) || Er.test(e) || Tr.test(e) || Tt.test(e) || St.test(e);
}, da = {
  youtube: (e) => e instanceof Array ? e.every((r) => mr.test(r)) : mr.test(e),
  soundcloud: (e) => dt.test(e) && !Or.test(e),
  vimeo: (e) => pt.test(e) && !Er.test(e) && !Tr.test(e),
  mux: (e) => yt.test(e),
  facebook: (e) => ht.test(e) || vt.test(e),
  streamable: (e) => mt.test(e),
  wistia: (e) => bt.test(e),
  twitch: (e) => _t.test(e) || gt.test(e),
  dailymotion: (e) => wt.test(e),
  mixcloud: (e) => Pt.test(e),
  vidyard: (e) => Ot.test(e),
  kaltura: (e) => Et.test(e),
  file: br
};
var Sr = Object.defineProperty, pa = Object.getOwnPropertyDescriptor, ya = Object.getOwnPropertyNames, ha = Object.prototype.hasOwnProperty, va = (e, r) => {
  for (var t in r)
    Sr(e, t, { get: r[t], enumerable: !0 });
}, ma = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of ya(r))
      !ha.call(e, o) && o !== t && Sr(e, o, { get: () => r[o], enumerable: !(n = pa(r, o)) || n.enumerable });
  return e;
}, ba = (e) => ma(Sr({}, "__esModule", { value: !0 }), e), Rt = {};
va(Rt, {
  default: () => ga
});
var _a = ba(Rt), ie = Ze, re = fa, ga = [
  {
    key: "youtube",
    name: "YouTube",
    canPlay: re.canPlay.youtube,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerYouTube' */
      "./YouTube-DWH69tEn.mjs"
    ).then((e) => e.Y))
  },
  {
    key: "soundcloud",
    name: "SoundCloud",
    canPlay: re.canPlay.soundcloud,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerSoundCloud' */
      "./SoundCloud-ySIK6fO1.mjs"
    ).then((e) => e.S))
  },
  {
    key: "vimeo",
    name: "Vimeo",
    canPlay: re.canPlay.vimeo,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerVimeo' */
      "./Vimeo-CYM8kkUv.mjs"
    ).then((e) => e.V))
  },
  {
    key: "mux",
    name: "Mux",
    canPlay: re.canPlay.mux,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerMux' */
      "./Mux-BW0Ea0zS.mjs"
    ).then((e) => e.M))
  },
  {
    key: "facebook",
    name: "Facebook",
    canPlay: re.canPlay.facebook,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerFacebook' */
      "./Facebook-z_Sh7xFd.mjs"
    ).then((e) => e.F))
  },
  {
    key: "streamable",
    name: "Streamable",
    canPlay: re.canPlay.streamable,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerStreamable' */
      "./Streamable-DRmIYlc8.mjs"
    ).then((e) => e.S))
  },
  {
    key: "wistia",
    name: "Wistia",
    canPlay: re.canPlay.wistia,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerWistia' */
      "./Wistia-DvSeOmoA.mjs"
    ).then((e) => e.W))
  },
  {
    key: "twitch",
    name: "Twitch",
    canPlay: re.canPlay.twitch,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerTwitch' */
      "./Twitch-CIQpi16G.mjs"
    ).then((e) => e.T))
  },
  {
    key: "dailymotion",
    name: "DailyMotion",
    canPlay: re.canPlay.dailymotion,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerDailyMotion' */
      "./DailyMotion-sw_hlM9U.mjs"
    ).then((e) => e.D))
  },
  {
    key: "mixcloud",
    name: "Mixcloud",
    canPlay: re.canPlay.mixcloud,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerMixcloud' */
      "./Mixcloud-oKps6885.mjs"
    ).then((e) => e.M))
  },
  {
    key: "vidyard",
    name: "Vidyard",
    canPlay: re.canPlay.vidyard,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerVidyard' */
      "./Vidyard-BotNroM_.mjs"
    ).then((e) => e.V))
  },
  {
    key: "kaltura",
    name: "Kaltura",
    canPlay: re.canPlay.kaltura,
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerKaltura' */
      "./Kaltura-CbMjmIf7.mjs"
    ).then((e) => e.K))
  },
  {
    key: "file",
    name: "FilePlayer",
    canPlay: re.canPlay.file,
    canEnablePIP: (e) => re.canPlay.file(e) && (document.pictureInPictureEnabled || (0, ie.supportsWebKitPresentationMode)()) && !re.AUDIO_EXTENSIONS.test(e),
    lazyPlayer: (0, ie.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerFilePlayer' */
      "./FilePlayer-CrUGIICi.mjs"
    ).then((e) => e.F))
  }
], Br = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function wa(e, r) {
  return !!(e === r || Br(e) && Br(r));
}
function Pa(e, r) {
  if (e.length !== r.length)
    return !1;
  for (var t = 0; t < e.length; t++)
    if (!wa(e[t], r[t]))
      return !1;
  return !0;
}
function Oa(e, r) {
  r === void 0 && (r = Pa);
  var t, n = [], o, i = !1;
  function f() {
    for (var u = [], d = 0; d < arguments.length; d++)
      u[d] = arguments[d];
    return i && t === this && r(u, n) || (o = e.apply(this, u), i = !0, t = this, n = u), o;
  }
  return f;
}
const Ea = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oa
}, Symbol.toStringTag, { value: "Module" })), Ta = /* @__PURE__ */ pn(Ea);
var Sa = typeof Element < "u", Ra = typeof Map == "function", xa = typeof Set == "function", ja = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Be(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var t, n, o;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length) return !1;
      for (n = t; n-- !== 0; )
        if (!Be(e[n], r[n])) return !1;
      return !0;
    }
    var i;
    if (Ra && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size) return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0])) return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!Be(n.value[1], r.get(n.value[0]))) return !1;
      return !0;
    }
    if (xa && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size) return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0])) return !1;
      return !0;
    }
    if (ja && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length) return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof r.valueOf == "function") return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof r.toString == "function") return e.toString() === r.toString();
    if (o = Object.keys(e), t = o.length, t !== Object.keys(r).length) return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[n])) return !1;
    if (Sa && e instanceof Element) return !1;
    for (n = t; n-- !== 0; )
      if (!((o[n] === "_owner" || o[n] === "__v" || o[n] === "__o") && e.$$typeof) && !Be(e[o[n]], r[o[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var xt = function(r, t) {
  try {
    return Be(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
}, _r = { exports: {} }, ze = { exports: {} }, k = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qr;
function Ca() {
  if (qr) return k;
  qr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, b = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, _ = e ? Symbol.for("react.suspense") : 60113, j = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, U = e ? Symbol.for("react.lazy") : 60116, I = e ? Symbol.for("react.block") : 60121, H = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, W = e ? Symbol.for("react.scope") : 60119;
  function V(v) {
    if (typeof v == "object" && v !== null) {
      var de = v.$$typeof;
      switch (de) {
        case r:
          switch (v = v.type, v) {
            case d:
            case b:
            case n:
            case i:
            case o:
            case _:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case u:
                case p:
                case U:
                case C:
                case f:
                  return v;
                default:
                  return de;
              }
          }
        case t:
          return de;
      }
    }
  }
  function q(v) {
    return V(v) === b;
  }
  return k.AsyncMode = d, k.ConcurrentMode = b, k.ContextConsumer = u, k.ContextProvider = f, k.Element = r, k.ForwardRef = p, k.Fragment = n, k.Lazy = U, k.Memo = C, k.Portal = t, k.Profiler = i, k.StrictMode = o, k.Suspense = _, k.isAsyncMode = function(v) {
    return q(v) || V(v) === d;
  }, k.isConcurrentMode = q, k.isContextConsumer = function(v) {
    return V(v) === u;
  }, k.isContextProvider = function(v) {
    return V(v) === f;
  }, k.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === r;
  }, k.isForwardRef = function(v) {
    return V(v) === p;
  }, k.isFragment = function(v) {
    return V(v) === n;
  }, k.isLazy = function(v) {
    return V(v) === U;
  }, k.isMemo = function(v) {
    return V(v) === C;
  }, k.isPortal = function(v) {
    return V(v) === t;
  }, k.isProfiler = function(v) {
    return V(v) === i;
  }, k.isStrictMode = function(v) {
    return V(v) === o;
  }, k.isSuspense = function(v) {
    return V(v) === _;
  }, k.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === b || v === i || v === o || v === _ || v === j || typeof v == "object" && v !== null && (v.$$typeof === U || v.$$typeof === C || v.$$typeof === f || v.$$typeof === u || v.$$typeof === p || v.$$typeof === H || v.$$typeof === F || v.$$typeof === W || v.$$typeof === I);
  }, k.typeOf = V, k;
}
var D = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kr;
function Aa() {
  return Kr || (Kr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, b = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, _ = e ? Symbol.for("react.suspense") : 60113, j = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, U = e ? Symbol.for("react.lazy") : 60116, I = e ? Symbol.for("react.block") : 60121, H = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, W = e ? Symbol.for("react.scope") : 60119;
    function V(y) {
      return typeof y == "string" || typeof y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      y === n || y === b || y === i || y === o || y === _ || y === j || typeof y == "object" && y !== null && (y.$$typeof === U || y.$$typeof === C || y.$$typeof === f || y.$$typeof === u || y.$$typeof === p || y.$$typeof === H || y.$$typeof === F || y.$$typeof === W || y.$$typeof === I);
    }
    function q(y) {
      if (typeof y == "object" && y !== null) {
        var ce = y.$$typeof;
        switch (ce) {
          case r:
            var we = y.type;
            switch (we) {
              case d:
              case b:
              case n:
              case i:
              case o:
              case _:
                return we;
              default:
                var he = we && we.$$typeof;
                switch (he) {
                  case u:
                  case p:
                  case U:
                  case C:
                  case f:
                    return he;
                  default:
                    return ce;
                }
            }
          case t:
            return ce;
        }
      }
    }
    var v = d, de = b, xe = u, je = f, me = r, Ce = p, be = n, _e = U, ne = C, ae = t, pe = i, se = o, fe = _, ye = !1;
    function ge(y) {
      return ye || (ye = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), c(y) || q(y) === d;
    }
    function c(y) {
      return q(y) === b;
    }
    function m(y) {
      return q(y) === u;
    }
    function T(y) {
      return q(y) === f;
    }
    function E(y) {
      return typeof y == "object" && y !== null && y.$$typeof === r;
    }
    function w(y) {
      return q(y) === p;
    }
    function A(y) {
      return q(y) === n;
    }
    function P(y) {
      return q(y) === U;
    }
    function O(y) {
      return q(y) === C;
    }
    function S(y) {
      return q(y) === t;
    }
    function $(y) {
      return q(y) === i;
    }
    function R(y) {
      return q(y) === o;
    }
    function G(y) {
      return q(y) === _;
    }
    D.AsyncMode = v, D.ConcurrentMode = de, D.ContextConsumer = xe, D.ContextProvider = je, D.Element = me, D.ForwardRef = Ce, D.Fragment = be, D.Lazy = _e, D.Memo = ne, D.Portal = ae, D.Profiler = pe, D.StrictMode = se, D.Suspense = fe, D.isAsyncMode = ge, D.isConcurrentMode = c, D.isContextConsumer = m, D.isContextProvider = T, D.isElement = E, D.isForwardRef = w, D.isFragment = A, D.isLazy = P, D.isMemo = O, D.isPortal = S, D.isProfiler = $, D.isStrictMode = R, D.isSuspense = G, D.isValidElementType = V, D.typeOf = q;
  }()), D;
}
var Zr;
function jt() {
  return Zr || (Zr = 1, process.env.NODE_ENV === "production" ? ze.exports = Ca() : ze.exports = Aa()), ze.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var sr, Xr;
function Ma() {
  if (Xr) return sr;
  Xr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var f = {}, u = 0; u < 10; u++)
        f["_" + String.fromCharCode(u)] = u;
      var d = Object.getOwnPropertyNames(f).map(function(p) {
        return f[p];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var b = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        b[p] = p;
      }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return sr = o() ? Object.assign : function(i, f) {
    for (var u, d = n(i), b, p = 1; p < arguments.length; p++) {
      u = Object(arguments[p]);
      for (var _ in u)
        r.call(u, _) && (d[_] = u[_]);
      if (e) {
        b = e(u);
        for (var j = 0; j < b.length; j++)
          t.call(u, b[j]) && (d[b[j]] = u[b[j]]);
      }
    }
    return d;
  }, sr;
}
var lr, Jr;
function Rr() {
  if (Jr) return lr;
  Jr = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return lr = e, lr;
}
var cr, Gr;
function Ct() {
  return Gr || (Gr = 1, cr = Function.call.bind(Object.prototype.hasOwnProperty)), cr;
}
var ur, Qr;
function $a() {
  if (Qr) return ur;
  Qr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = Rr(), t = {}, n = Ct();
    e = function(i) {
      var f = "Warning: " + i;
      typeof console < "u" && console.error(f);
      try {
        throw new Error(f);
      } catch {
      }
    };
  }
  function o(i, f, u, d, b) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in i)
        if (n(i, p)) {
          var _;
          try {
            if (typeof i[p] != "function") {
              var j = Error(
                (d || "React class") + ": " + u + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw j.name = "Invariant Violation", j;
            }
            _ = i[p](f, p, d, u, null, r);
          } catch (U) {
            _ = U;
          }
          if (_ && !(_ instanceof Error) && e(
            (d || "React class") + ": type specification of " + u + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof _ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), _ instanceof Error && !(_.message in t)) {
            t[_.message] = !0;
            var C = b ? b() : "";
            e(
              "Failed " + u + " type: " + _.message + (C ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, ur = o, ur;
}
var fr, et;
function Ia() {
  if (et) return fr;
  et = 1;
  var e = jt(), r = Ma(), t = Rr(), n = Ct(), o = $a(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var d = "Warning: " + u;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function f() {
    return null;
  }
  return fr = function(u, d) {
    var b = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function _(c) {
      var m = c && (b && c[b] || c[p]);
      if (typeof m == "function")
        return m;
    }
    var j = "<<anonymous>>", C = {
      array: F("array"),
      bigint: F("bigint"),
      bool: F("boolean"),
      func: F("function"),
      number: F("number"),
      object: F("object"),
      string: F("string"),
      symbol: F("symbol"),
      any: W(),
      arrayOf: V,
      element: q(),
      elementType: v(),
      instanceOf: de,
      node: Ce(),
      objectOf: je,
      oneOf: xe,
      oneOfType: me,
      shape: _e,
      exact: ne
    };
    function U(c, m) {
      return c === m ? c !== 0 || 1 / c === 1 / m : c !== c && m !== m;
    }
    function I(c, m) {
      this.message = c, this.data = m && typeof m == "object" ? m : {}, this.stack = "";
    }
    I.prototype = Error.prototype;
    function H(c) {
      if (process.env.NODE_ENV !== "production")
        var m = {}, T = 0;
      function E(A, P, O, S, $, R, G) {
        if (S = S || j, R = R || O, G !== t) {
          if (d) {
            var y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw y.name = "Invariant Violation", y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = S + ":" + O;
            !m[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + R + "` prop on `" + S + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), m[ce] = !0, T++);
          }
        }
        return P[O] == null ? A ? P[O] === null ? new I("The " + $ + " `" + R + "` is marked as required " + ("in `" + S + "`, but its value is `null`.")) : new I("The " + $ + " `" + R + "` is marked as required in " + ("`" + S + "`, but its value is `undefined`.")) : null : c(P, O, S, $, R);
      }
      var w = E.bind(null, !1);
      return w.isRequired = E.bind(null, !0), w;
    }
    function F(c) {
      function m(T, E, w, A, P, O) {
        var S = T[E], $ = se(S);
        if ($ !== c) {
          var R = fe(S);
          return new I(
            "Invalid " + A + " `" + P + "` of type " + ("`" + R + "` supplied to `" + w + "`, expected ") + ("`" + c + "`."),
            { expectedType: c }
          );
        }
        return null;
      }
      return H(m);
    }
    function W() {
      return H(f);
    }
    function V(c) {
      function m(T, E, w, A, P) {
        if (typeof c != "function")
          return new I("Property `" + P + "` of component `" + w + "` has invalid PropType notation inside arrayOf.");
        var O = T[E];
        if (!Array.isArray(O)) {
          var S = se(O);
          return new I("Invalid " + A + " `" + P + "` of type " + ("`" + S + "` supplied to `" + w + "`, expected an array."));
        }
        for (var $ = 0; $ < O.length; $++) {
          var R = c(O, $, w, A, P + "[" + $ + "]", t);
          if (R instanceof Error)
            return R;
        }
        return null;
      }
      return H(m);
    }
    function q() {
      function c(m, T, E, w, A) {
        var P = m[T];
        if (!u(P)) {
          var O = se(P);
          return new I("Invalid " + w + " `" + A + "` of type " + ("`" + O + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return H(c);
    }
    function v() {
      function c(m, T, E, w, A) {
        var P = m[T];
        if (!e.isValidElementType(P)) {
          var O = se(P);
          return new I("Invalid " + w + " `" + A + "` of type " + ("`" + O + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return H(c);
    }
    function de(c) {
      function m(T, E, w, A, P) {
        if (!(T[E] instanceof c)) {
          var O = c.name || j, S = ge(T[E]);
          return new I("Invalid " + A + " `" + P + "` of type " + ("`" + S + "` supplied to `" + w + "`, expected ") + ("instance of `" + O + "`."));
        }
        return null;
      }
      return H(m);
    }
    function xe(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), f;
      function m(T, E, w, A, P) {
        for (var O = T[E], S = 0; S < c.length; S++)
          if (U(O, c[S]))
            return null;
        var $ = JSON.stringify(c, function(G, y) {
          var ce = fe(y);
          return ce === "symbol" ? String(y) : y;
        });
        return new I("Invalid " + A + " `" + P + "` of value `" + String(O) + "` " + ("supplied to `" + w + "`, expected one of " + $ + "."));
      }
      return H(m);
    }
    function je(c) {
      function m(T, E, w, A, P) {
        if (typeof c != "function")
          return new I("Property `" + P + "` of component `" + w + "` has invalid PropType notation inside objectOf.");
        var O = T[E], S = se(O);
        if (S !== "object")
          return new I("Invalid " + A + " `" + P + "` of type " + ("`" + S + "` supplied to `" + w + "`, expected an object."));
        for (var $ in O)
          if (n(O, $)) {
            var R = c(O, $, w, A, P + "." + $, t);
            if (R instanceof Error)
              return R;
          }
        return null;
      }
      return H(m);
    }
    function me(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), f;
      for (var m = 0; m < c.length; m++) {
        var T = c[m];
        if (typeof T != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ye(T) + " at index " + m + "."
          ), f;
      }
      function E(w, A, P, O, S) {
        for (var $ = [], R = 0; R < c.length; R++) {
          var G = c[R], y = G(w, A, P, O, S, t);
          if (y == null)
            return null;
          y.data && n(y.data, "expectedType") && $.push(y.data.expectedType);
        }
        var ce = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new I("Invalid " + O + " `" + S + "` supplied to " + ("`" + P + "`" + ce + "."));
      }
      return H(E);
    }
    function Ce() {
      function c(m, T, E, w, A) {
        return ae(m[T]) ? null : new I("Invalid " + w + " `" + A + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return H(c);
    }
    function be(c, m, T, E, w) {
      return new I(
        (c || "React class") + ": " + m + " type `" + T + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + w + "`."
      );
    }
    function _e(c) {
      function m(T, E, w, A, P) {
        var O = T[E], S = se(O);
        if (S !== "object")
          return new I("Invalid " + A + " `" + P + "` of type `" + S + "` " + ("supplied to `" + w + "`, expected `object`."));
        for (var $ in c) {
          var R = c[$];
          if (typeof R != "function")
            return be(w, A, P, $, fe(R));
          var G = R(O, $, w, A, P + "." + $, t);
          if (G)
            return G;
        }
        return null;
      }
      return H(m);
    }
    function ne(c) {
      function m(T, E, w, A, P) {
        var O = T[E], S = se(O);
        if (S !== "object")
          return new I("Invalid " + A + " `" + P + "` of type `" + S + "` " + ("supplied to `" + w + "`, expected `object`."));
        var $ = r({}, T[E], c);
        for (var R in $) {
          var G = c[R];
          if (n(c, R) && typeof G != "function")
            return be(w, A, P, R, fe(G));
          if (!G)
            return new I(
              "Invalid " + A + " `" + P + "` key `" + R + "` supplied to `" + w + "`.\nBad object: " + JSON.stringify(T[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(c), null, "  ")
            );
          var y = G(O, R, w, A, P + "." + R, t);
          if (y)
            return y;
        }
        return null;
      }
      return H(m);
    }
    function ae(c) {
      switch (typeof c) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !c;
        case "object":
          if (Array.isArray(c))
            return c.every(ae);
          if (c === null || u(c))
            return !0;
          var m = _(c);
          if (m) {
            var T = m.call(c), E;
            if (m !== c.entries) {
              for (; !(E = T.next()).done; )
                if (!ae(E.value))
                  return !1;
            } else
              for (; !(E = T.next()).done; ) {
                var w = E.value;
                if (w && !ae(w[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function pe(c, m) {
      return c === "symbol" ? !0 : m ? m["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && m instanceof Symbol : !1;
    }
    function se(c) {
      var m = typeof c;
      return Array.isArray(c) ? "array" : c instanceof RegExp ? "object" : pe(m, c) ? "symbol" : m;
    }
    function fe(c) {
      if (typeof c > "u" || c === null)
        return "" + c;
      var m = se(c);
      if (m === "object") {
        if (c instanceof Date)
          return "date";
        if (c instanceof RegExp)
          return "regexp";
      }
      return m;
    }
    function ye(c) {
      var m = fe(c);
      switch (m) {
        case "array":
        case "object":
          return "an " + m;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + m;
        default:
          return m;
      }
    }
    function ge(c) {
      return !c.constructor || !c.constructor.name ? j : c.constructor.name;
    }
    return C.checkPropTypes = o, C.resetWarningCache = o.resetWarningCache, C.PropTypes = C, C;
  }, fr;
}
var dr, rt;
function Na() {
  if (rt) return dr;
  rt = 1;
  var e = Rr();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, dr = function() {
    function n(f, u, d, b, p, _) {
      if (_ !== e) {
        var j = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw j.name = "Invariant Violation", j;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, dr;
}
if (process.env.NODE_ENV !== "production") {
  var ka = jt(), Da = !0;
  _r.exports = Ia()(ka.isElement, Da);
} else
  _r.exports = Na()();
var La = _r.exports, Ua = Object.create, Xe = Object.defineProperty, Fa = Object.getOwnPropertyDescriptor, Wa = Object.getOwnPropertyNames, Ha = Object.getPrototypeOf, Va = Object.prototype.hasOwnProperty, Ya = (e, r) => {
  for (var t in r)
    Xe(e, t, { get: r[t], enumerable: !0 });
}, At = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of Wa(r))
      !Va.call(e, o) && o !== t && Xe(e, o, { get: () => r[o], enumerable: !(n = Fa(r, o)) || n.enumerable });
  return e;
}, za = (e, r, t) => (t = e != null ? Ua(Ha(e)) : {}, At(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? Xe(t, "default", { value: e, enumerable: !0 }) : t,
  e
)), Ba = (e) => At(Xe({}, "__esModule", { value: !0 }), e), Mt = {};
Ya(Mt, {
  defaultProps: () => Za,
  propTypes: () => Ka
});
var $t = Ba(Mt), qa = za(La);
const { string: X, bool: te, number: Te, array: pr, oneOfType: Ne, shape: le, object: Q, func: Z, node: tt } = qa.default, Ka = {
  url: Ne([X, pr, Q]),
  playing: te,
  loop: te,
  controls: te,
  volume: Te,
  muted: te,
  playbackRate: Te,
  width: Ne([X, Te]),
  height: Ne([X, Te]),
  style: Q,
  progressInterval: Te,
  playsinline: te,
  pip: te,
  stopOnUnmount: te,
  light: Ne([te, X, Q]),
  playIcon: tt,
  previewTabIndex: Te,
  previewAriaLabel: X,
  fallback: tt,
  oEmbedUrl: X,
  wrapper: Ne([
    X,
    Z,
    le({ render: Z.isRequired })
  ]),
  config: le({
    soundcloud: le({
      options: Q
    }),
    youtube: le({
      playerVars: Q,
      embedOptions: Q,
      onUnstarted: Z
    }),
    facebook: le({
      appId: X,
      version: X,
      playerId: X,
      attributes: Q
    }),
    dailymotion: le({
      params: Q
    }),
    vimeo: le({
      playerOptions: Q,
      title: X
    }),
    mux: le({
      attributes: Q,
      version: X
    }),
    file: le({
      attributes: Q,
      tracks: pr,
      forceVideo: te,
      forceAudio: te,
      forceHLS: te,
      forceSafariHLS: te,
      forceDisableHls: te,
      forceDASH: te,
      forceFLV: te,
      hlsOptions: Q,
      hlsVersion: X,
      dashVersion: X,
      flvVersion: X
    }),
    wistia: le({
      options: Q,
      playerId: X,
      customControls: pr
    }),
    mixcloud: le({
      options: Q
    }),
    twitch: le({
      options: Q,
      playerId: X
    }),
    vidyard: le({
      options: Q
    })
  }),
  onReady: Z,
  onStart: Z,
  onPlay: Z,
  onPause: Z,
  onBuffer: Z,
  onBufferEnd: Z,
  onEnded: Z,
  onError: Z,
  onDuration: Z,
  onSeek: Z,
  onPlaybackRateChange: Z,
  onPlaybackQualityChange: Z,
  onProgress: Z,
  onClickPreview: Z,
  onEnablePIP: Z,
  onDisablePIP: Z
}, J = () => {
}, Za = {
  playing: !1,
  loop: !1,
  controls: !1,
  volume: null,
  muted: !1,
  playbackRate: 1,
  width: "640px",
  height: "360px",
  style: {},
  progressInterval: 1e3,
  playsinline: !1,
  pip: !1,
  stopOnUnmount: !0,
  light: !1,
  fallback: null,
  wrapper: "div",
  previewTabIndex: 0,
  previewAriaLabel: "",
  oEmbedUrl: "https://noembed.com/embed?url={url}",
  config: {
    soundcloud: {
      options: {
        visual: !0,
        // Undocumented, but makes player fill container and look better
        buying: !1,
        liking: !1,
        download: !1,
        sharing: !1,
        show_comments: !1,
        show_playcount: !1
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: J
    },
    facebook: {
      appId: "1309697205772819",
      version: "v3.3",
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        "endscreen-enable": !1
      }
    },
    vimeo: {
      playerOptions: {
        autopause: !1,
        byline: !1,
        portrait: !1,
        title: !1
      },
      title: null
    },
    mux: {
      attributes: {},
      version: "2"
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: !1,
      forceAudio: !1,
      forceHLS: !1,
      forceDASH: !1,
      forceFLV: !1,
      hlsOptions: {},
      hlsVersion: "1.1.4",
      dashVersion: "3.1.3",
      flvVersion: "1.5.0",
      forceDisableHls: !1
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: J,
  onStart: J,
  onPlay: J,
  onPause: J,
  onBuffer: J,
  onBufferEnd: J,
  onEnded: J,
  onError: J,
  onDuration: J,
  onSeek: J,
  onPlaybackRateChange: J,
  onPlaybackQualityChange: J,
  onProgress: J,
  onClickPreview: J,
  onEnablePIP: J,
  onDisablePIP: J
};
var Xa = Object.create, We = Object.defineProperty, Ja = Object.getOwnPropertyDescriptor, Ga = Object.getOwnPropertyNames, Qa = Object.getPrototypeOf, eo = Object.prototype.hasOwnProperty, ro = (e, r, t) => r in e ? We(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, to = (e, r) => {
  for (var t in r)
    We(e, t, { get: r[t], enumerable: !0 });
}, It = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of Ga(r))
      !eo.call(e, o) && o !== t && We(e, o, { get: () => r[o], enumerable: !(n = Ja(r, o)) || n.enumerable });
  return e;
}, Nt = (e, r, t) => (t = e != null ? Xa(Qa(e)) : {}, It(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? We(t, "default", { value: e, enumerable: !0 }) : t,
  e
)), no = (e) => It(We({}, "__esModule", { value: !0 }), e), B = (e, r, t) => (ro(e, typeof r != "symbol" ? r + "" : r, t), t), kt = {};
to(kt, {
  default: () => Je
});
var ao = no(kt), nt = Nt(Fe), oo = Nt(xt), Dt = $t, io = Ze;
const so = 5e3;
class Je extends nt.Component {
  constructor() {
    super(...arguments), B(this, "mounted", !1), B(this, "isReady", !1), B(this, "isPlaying", !1), B(this, "isLoading", !0), B(this, "loadOnReady", null), B(this, "startOnPlay", !0), B(this, "seekOnPlay", null), B(this, "onDurationCalled", !1), B(this, "handlePlayerMount", (r) => {
      if (this.player) {
        this.progress();
        return;
      }
      this.player = r, this.player.load(this.props.url), this.progress();
    }), B(this, "getInternalPlayer", (r) => this.player ? this.player[r] : null), B(this, "progress", () => {
      if (this.props.url && this.player && this.isReady) {
        const r = this.getCurrentTime() || 0, t = this.getSecondsLoaded(), n = this.getDuration();
        if (n) {
          const o = {
            playedSeconds: r,
            played: r / n
          };
          t !== null && (o.loadedSeconds = t, o.loaded = t / n), (o.playedSeconds !== this.prevPlayed || o.loadedSeconds !== this.prevLoaded) && this.props.onProgress(o), this.prevPlayed = o.playedSeconds, this.prevLoaded = o.loadedSeconds;
        }
      }
      this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
    }), B(this, "handleReady", () => {
      if (!this.mounted)
        return;
      this.isReady = !0, this.isLoading = !1;
      const { onReady: r, playing: t, volume: n, muted: o } = this.props;
      r(), !o && n !== null && this.player.setVolume(n), this.loadOnReady ? (this.player.load(this.loadOnReady, !0), this.loadOnReady = null) : t && this.player.play(), this.handleDurationCheck();
    }), B(this, "handlePlay", () => {
      this.isPlaying = !0, this.isLoading = !1;
      const { onStart: r, onPlay: t, playbackRate: n } = this.props;
      this.startOnPlay && (this.player.setPlaybackRate && n !== 1 && this.player.setPlaybackRate(n), r(), this.startOnPlay = !1), t(), this.seekOnPlay && (this.seekTo(this.seekOnPlay), this.seekOnPlay = null), this.handleDurationCheck();
    }), B(this, "handlePause", (r) => {
      this.isPlaying = !1, this.isLoading || this.props.onPause(r);
    }), B(this, "handleEnded", () => {
      const { activePlayer: r, loop: t, onEnded: n } = this.props;
      r.loopOnEnded && t && this.seekTo(0), t || (this.isPlaying = !1, n());
    }), B(this, "handleError", (...r) => {
      this.isLoading = !1, this.props.onError(...r);
    }), B(this, "handleDurationCheck", () => {
      clearTimeout(this.durationCheckTimeout);
      const r = this.getDuration();
      r ? this.onDurationCalled || (this.props.onDuration(r), this.onDurationCalled = !0) : this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
    }), B(this, "handleLoaded", () => {
      this.isLoading = !1;
    });
  }
  componentDidMount() {
    this.mounted = !0;
  }
  componentWillUnmount() {
    clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
  }
  componentDidUpdate(r) {
    if (!this.player)
      return;
    const { url: t, playing: n, volume: o, muted: i, playbackRate: f, pip: u, loop: d, activePlayer: b, disableDeferredLoading: p } = this.props;
    if (!(0, oo.default)(r.url, t)) {
      if (this.isLoading && !b.forceLoad && !p && !(0, io.isMediaStream)(t)) {
        console.warn(`ReactPlayer: the attempt to load ${t} is being deferred until the player has loaded`), this.loadOnReady = t;
        return;
      }
      this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(t, this.isReady);
    }
    !r.playing && n && !this.isPlaying && this.player.play(), r.playing && !n && this.isPlaying && this.player.pause(), !r.pip && u && this.player.enablePIP && this.player.enablePIP(), r.pip && !u && this.player.disablePIP && this.player.disablePIP(), r.volume !== o && o !== null && this.player.setVolume(o), r.muted !== i && (i ? this.player.mute() : (this.player.unmute(), o !== null && setTimeout(() => this.player.setVolume(o)))), r.playbackRate !== f && this.player.setPlaybackRate && this.player.setPlaybackRate(f), r.loop !== d && this.player.setLoop && this.player.setLoop(d);
  }
  getDuration() {
    return this.isReady ? this.player.getDuration() : null;
  }
  getCurrentTime() {
    return this.isReady ? this.player.getCurrentTime() : null;
  }
  getSecondsLoaded() {
    return this.isReady ? this.player.getSecondsLoaded() : null;
  }
  seekTo(r, t, n) {
    if (!this.isReady) {
      r !== 0 && (this.seekOnPlay = r, setTimeout(() => {
        this.seekOnPlay = null;
      }, so));
      return;
    }
    if (t ? t === "fraction" : r > 0 && r < 1) {
      const i = this.player.getDuration();
      if (!i) {
        console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
        return;
      }
      this.player.seekTo(i * r, n);
      return;
    }
    this.player.seekTo(r, n);
  }
  render() {
    const r = this.props.activePlayer;
    return r ? /* @__PURE__ */ nt.default.createElement(
      r,
      {
        ...this.props,
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }
    ) : null;
  }
}
B(Je, "displayName", "Player");
B(Je, "propTypes", Dt.propTypes);
B(Je, "defaultProps", Dt.defaultProps);
var lo = Object.create, He = Object.defineProperty, co = Object.getOwnPropertyDescriptor, uo = Object.getOwnPropertyNames, fo = Object.getPrototypeOf, po = Object.prototype.hasOwnProperty, yo = (e, r, t) => r in e ? He(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ho = (e, r) => {
  for (var t in r)
    He(e, t, { get: r[t], enumerable: !0 });
}, Lt = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of uo(r))
      !po.call(e, o) && o !== t && He(e, o, { get: () => r[o], enumerable: !(n = co(r, o)) || n.enumerable });
  return e;
}, Ve = (e, r, t) => (t = e != null ? lo(fo(e)) : {}, Lt(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? He(t, "default", { value: e, enumerable: !0 }) : t,
  e
)), vo = (e) => Lt(He({}, "__esModule", { value: !0 }), e), z = (e, r, t) => (yo(e, typeof r != "symbol" ? r + "" : r, t), t), Ut = {};
ho(Ut, {
  createReactPlayer: () => To
});
var mo = vo(Ut), Se = Ve(Fe), bo = Ve(st), yr = Ve(Ta), at = Ve(xt), De = $t, Ft = Ze, _o = Ve(ao);
const go = (0, Ft.lazy)(() => import(
  /* webpackChunkName: 'reactPlayerPreview' */
  "./Preview-BDI5KzHo.mjs"
).then((e) => e.P)), wo = typeof window < "u" && window.document && typeof document < "u", Po = typeof or < "u" && or.window && or.window.document, Oo = Object.keys(De.propTypes), Eo = wo || Po ? Se.Suspense : () => null, ke = [], To = (e, r) => {
  var t;
  return t = class extends Se.Component {
    constructor() {
      super(...arguments), z(this, "state", {
        showPreview: !!this.props.light
      }), z(this, "references", {
        wrapper: (n) => {
          this.wrapper = n;
        },
        player: (n) => {
          this.player = n;
        }
      }), z(this, "handleClickPreview", (n) => {
        this.setState({ showPreview: !1 }), this.props.onClickPreview(n);
      }), z(this, "showPreview", () => {
        this.setState({ showPreview: !0 });
      }), z(this, "getDuration", () => this.player ? this.player.getDuration() : null), z(this, "getCurrentTime", () => this.player ? this.player.getCurrentTime() : null), z(this, "getSecondsLoaded", () => this.player ? this.player.getSecondsLoaded() : null), z(this, "getInternalPlayer", (n = "player") => this.player ? this.player.getInternalPlayer(n) : null), z(this, "seekTo", (n, o, i) => {
        if (!this.player)
          return null;
        this.player.seekTo(n, o, i);
      }), z(this, "handleReady", () => {
        this.props.onReady(this);
      }), z(this, "getActivePlayer", (0, yr.default)((n) => {
        for (const o of [...ke, ...e])
          if (o.canPlay(n))
            return o;
        return r || null;
      })), z(this, "getConfig", (0, yr.default)((n, o) => {
        const { config: i } = this.props;
        return bo.default.all([
          De.defaultProps.config,
          De.defaultProps.config[o] || {},
          i,
          i[o] || {}
        ]);
      })), z(this, "getAttributes", (0, yr.default)((n) => (0, Ft.omit)(this.props, Oo))), z(this, "renderActivePlayer", (n) => {
        if (!n)
          return null;
        const o = this.getActivePlayer(n);
        if (!o)
          return null;
        const i = this.getConfig(n, o.key);
        return /* @__PURE__ */ Se.default.createElement(
          _o.default,
          {
            ...this.props,
            key: o.key,
            ref: this.references.player,
            config: i,
            activePlayer: o.lazyPlayer || o,
            onReady: this.handleReady
          }
        );
      });
    }
    shouldComponentUpdate(n, o) {
      return !(0, at.default)(this.props, n) || !(0, at.default)(this.state, o);
    }
    componentDidUpdate(n) {
      const { light: o } = this.props;
      !n.light && o && this.setState({ showPreview: !0 }), n.light && !o && this.setState({ showPreview: !1 });
    }
    renderPreview(n) {
      if (!n)
        return null;
      const { light: o, playIcon: i, previewTabIndex: f, oEmbedUrl: u, previewAriaLabel: d } = this.props;
      return /* @__PURE__ */ Se.default.createElement(
        go,
        {
          url: n,
          light: o,
          playIcon: i,
          previewTabIndex: f,
          previewAriaLabel: d,
          oEmbedUrl: u,
          onClick: this.handleClickPreview
        }
      );
    }
    render() {
      const { url: n, style: o, width: i, height: f, fallback: u, wrapper: d } = this.props, { showPreview: b } = this.state, p = this.getAttributes(n), _ = typeof d == "string" ? this.references.wrapper : void 0;
      return /* @__PURE__ */ Se.default.createElement(d, { ref: _, style: { ...o, width: i, height: f }, ...p }, /* @__PURE__ */ Se.default.createElement(Eo, { fallback: u }, b ? this.renderPreview(n) : this.renderActivePlayer(n)));
    }
  }, z(t, "displayName", "ReactPlayer"), z(t, "propTypes", De.propTypes), z(t, "defaultProps", De.defaultProps), z(t, "addCustomPlayer", (n) => {
    ke.push(n);
  }), z(t, "removeCustomPlayers", () => {
    ke.length = 0;
  }), z(t, "canPlay", (n) => {
    for (const o of [...ke, ...e])
      if (o.canPlay(n))
        return !0;
    return !1;
  }), z(t, "canEnablePIP", (n) => {
    for (const o of [...ke, ...e])
      if (o.canEnablePIP && o.canEnablePIP(n))
        return !0;
    return !1;
  }), t;
};
var So = Object.create, Ge = Object.defineProperty, Ro = Object.getOwnPropertyDescriptor, xo = Object.getOwnPropertyNames, jo = Object.getPrototypeOf, Co = Object.prototype.hasOwnProperty, Ao = (e, r) => {
  for (var t in r)
    Ge(e, t, { get: r[t], enumerable: !0 });
}, Wt = (e, r, t, n) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (let o of xo(r))
      !Co.call(e, o) && o !== t && Ge(e, o, { get: () => r[o], enumerable: !(n = Ro(r, o)) || n.enumerable });
  return e;
}, Mo = (e, r, t) => (t = e != null ? So(jo(e)) : {}, Wt(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? Ge(t, "default", { value: e, enumerable: !0 }) : t,
  e
)), $o = (e) => Wt(Ge({}, "__esModule", { value: !0 }), e), Ht = {};
Ao(Ht, {
  default: () => Do
});
var Io = $o(Ht), gr = Mo(_a), No = mo;
const ko = gr.default[gr.default.length - 1];
var Do = (0, No.createReactPlayer)(gr.default, ko);
const Lo = /* @__PURE__ */ dn(Io), Bo = ({
  title: e,
  backgroundImage: r,
  gradient: t = !1,
  fixedheight: n = !0,
  stairway: o = !0,
  text: i,
  video: f,
  children: u,
  className: d
}) => {
  const [b, p] = Le(!1);
  return qe(() => {
    typeof window < "u" && p(!0);
  }, []), b ? /* @__PURE__ */ s.jsxs(
    "div",
    {
      style: {
        background: `${t ? "linear-gradient(90deg, #005d76 0%, transparent 100%), " : ""}url(${r}) no-repeat center center / cover`
      },
      "data-gradient": t,
      className: `wb-hero ${d} ${n == !1 && "wb-hero--autoheight"} ${o == !0 && "wb-hero--stairway"} `,
      children: [
        /* @__PURE__ */ s.jsx("span", { role: "img", "aria-label": `background image for: ${e}` }),
        f && b ? /* @__PURE__ */ s.jsx("div", { className: "wb-hero__backgroundVideo", children: /* @__PURE__ */ s.jsx(
          Lo,
          {
            url: f,
            width: "100%",
            height: "100%",
            controls: !1,
            muted: !0,
            loop: !0,
            playing: !0,
            "aria-label": "Background video"
          }
        ) }) : null,
        /* @__PURE__ */ s.jsx("div", { className: "wb-container", children: /* @__PURE__ */ s.jsxs("div", { className: "wb-hero__content", children: [
          /* @__PURE__ */ s.jsx("h1", { className: "wb-hero__title", children: e }),
          i && /* @__PURE__ */ s.jsx(
            "div",
            {
              dangerouslySetInnerHTML: { __html: i },
              className: "wb-hero__content__text"
            }
          ),
          u && /* @__PURE__ */ s.jsx("div", { children: u })
        ] }) })
      ]
    }
  ) : null;
}, qo = ({
  small: e = !1,
  classname: r = "",
  inline: t = !0,
  text: n = ""
}) => /* @__PURE__ */ s.jsx("i", { "aria-busy": "true", "aria-live": "polite", "aria-label": n || "Loading", "data-text": n, className: "wb-loader " + (r || "") + (e ? " wb-loader--sm " : "") + (t ? " wb-loader--inline " : "") }), Ko = () => /* @__PURE__ */ s.jsxs("svg", { id: "logo", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 66.313", role: "img", "aria-labelledby": "wblogotitle", children: [
  /* @__PURE__ */ s.jsx("title", { id: "wblogotitle", children: "Logo Witteveen+Bos" }),
  /* @__PURE__ */ s.jsxs("g", { id: "Logo_Grouped", children: [
    /* @__PURE__ */ s.jsx("path", { id: "Zwart_Vlak", d: "M179.924,0V24.9H0V66.313H179.924V45.342h-8.217v-4.06h8.217l0-8.137h4.054v8.137h72L256,0Z", fill: "#080d0d" }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "B",
        d: "M424.709,31.47h5.578c1.579,0,3.154.7,3.154,2.53,0,2.13-1.223,3.058-3.36,3.058h-5.373Zm-4.209,9.2h8.9c4.3,0,5.432-.728,6.633-1.893a6.066,6.066,0,0,0,1.826-4.31c0-2.071-.671-4.1-3.241-5.07a4.2,4.2,0,0,0,2.57-4.283c0-2.153-1.315-5.357-6.455-5.357H420.5Zm4.209-17.294h5.021c1.986,0,3.2.528,3.2,2.244s-1.37,2.33-3.1,2.33h-5.117Z",
        transform: "translate(-228.542 -10.767)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "O",
        d: "M478.992,38.925c0,1.98-.584,4.715-3.739,4.715s-3.739-2.731-3.739-4.715.584-4.719,3.739-4.719,3.739,2.731,3.739,4.719m4.209,0c0-5.593-3.771-8.155-7.948-8.155s-7.943,2.562-7.943,8.155,3.766,8.155,7.943,8.155,7.948-2.553,7.948-8.155",
        transform: "translate(-253.984 -16.766)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "S",
        d: "M519.5,35.864c-.174-.992-.525-2.039-2.739-2.039s-2.515.846-2.515,1.515c0,2.444,9.728.669,9.728,6.371,0,4.515-4.382,5.334-6.806,5.334-3.533,0-7.363-1.224-7.477-5.361h4.2c0,1.311.822,2.276,3.392,2.276,2.1,0,2.6-1.019,2.6-1.6,0-2.59-9.641-.642-9.641-6.435,0-2.276,1.433-5.184,6.281-5.184,3.04,0,6.665.755,6.984,5.124Z",
        transform: "translate(-277.017 -16.75)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "W",
        d: "M23.48,74.76h4.675c2.689,11.446,2.954,12.9,3.332,15.291h.059c.379-2.184.7-4.31,2.922-15.291h4.643c2.456,11.473,2.661,12.584,3.127,15.291H42.3c.352-1.98.7-3.786,3.419-15.291h4.437L44.26,95.672H40.046C37.887,85.419,37.5,83.384,36.805,79.361h-.059c-.644,4.019-1,5.52-3.246,16.311H29.392Z",
        transform: "translate(-12.761 -40.737)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx("path", { id: "I", d: "M93.478,95.427H89.37V79.953h4.108Zm0-17.33H89.37V74.31h4.108Z", transform: "translate(-48.573 -40.491)", fill: "#fff" }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "T",
        d: "M114.31,81.641h2.543v2.913H114.31v8.419c0,.91.032,1.252,1.7,1.252a8.085,8.085,0,0,0,.844-.059v3.1c-.644.027-1.283.055-1.926.055H114.4c-3.538,0-4.182-1.338-4.182-3.35V84.554h-2.1V81.641h2.1V77.45h4.108Z",
        transform: "translate(-58.763 -42.202)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "T_2",
        d: "M140.93,81.641h2.543v2.913H140.93v8.419c0,.91.032,1.252,1.7,1.252a8.085,8.085,0,0,0,.845-.059v3.1c-.644.027-1.283.055-1.926.055h-.525c-3.538,0-4.182-1.338-4.182-3.35V84.554h-2.1V81.641h2.1V77.45h4.108Z",
        transform: "translate(-73.231 -42.202)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "E_3",
        d: "M164.569,92.378c.233-2.039,1.255-3.263,3.2-3.263,1.315,0,2.922.76,3.154,3.263Zm6.163,4.751a2.625,2.625,0,0,1-2.629,1.688c-3.3,0-3.533-2.621-3.652-3.786h10.664V94.3c0-7.081-4.236-8.533-7.3-8.533-6.806,0-7.45,5.971-7.45,7.832,0,6.371,3.36,8.479,7.76,8.479a6.752,6.752,0,0,0,6.847-4.952Z",
        transform: "translate(-87.156 -46.736)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx("path", { id: "V", d: "M207,102.156h-4.3l-5.578-15.5h4.56L204.9,98.079h.055l3.305-11.419h4.35Z", transform: "translate(-107.14 -47.221)", fill: "#fff" }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "E_1",
        d: "M239.689,92.378c.233-2.039,1.255-3.263,3.2-3.263,1.315,0,2.922.76,3.159,3.263Zm6.163,4.751a2.625,2.625,0,0,1-2.629,1.688c-3.3,0-3.533-2.621-3.652-3.786h10.664V94.3c0-7.081-4.236-8.533-7.3-8.533-6.806,0-7.45,5.971-7.45,7.832,0,6.371,3.36,8.479,7.76,8.479a6.748,6.748,0,0,0,6.847-4.952Z",
        transform: "translate(-127.984 -46.736)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "E_2",
        d: "M280.989,92.378c.233-2.039,1.255-3.263,3.2-3.263,1.315,0,2.922.76,3.159,3.263Zm6.163,4.751a2.625,2.625,0,0,1-2.629,1.688c-3.3,0-3.533-2.621-3.652-3.786h10.664V94.3c0-7.081-4.236-8.533-7.3-8.533-6.806,0-7.45,5.971-7.45,7.832,0,6.371,3.36,8.479,7.76,8.479a6.752,6.752,0,0,0,6.847-4.952Z",
        transform: "translate(-150.43 -46.736)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        id: "N",
        d: "M332.7,101.676H328.6V92.251c0-1.138-.059-3.058-2.661-3.058-1.826,0-3.2,1.224-3.2,3.582v8.884H318.63V86.184h3.917V88.46h.059a5.024,5.024,0,0,1,4.675-2.676c3.036,0,5.4,1.775,5.4,5.184Z",
        transform: "translate(-173.176 -46.741)",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ s.jsx("path", { id: "Blauw_Vlak", d: "M329.034,30.94v5.352H323.67v5.466H355.84V30.94Z", transform: "translate(-175.915 -16.859)", fill: "#009fdc" }),
    /* @__PURE__ */ s.jsx("rect", { id: "Plus_Boven", width: "4.049", height: "8.137", transform: "translate(179.924 33.145)", fill: "#fff" }),
    /* @__PURE__ */ s.jsx("rect", { id: "Plus_Links", width: "8.217", height: "4.06", transform: "translate(171.707 41.282)", fill: "#fff" })
  ] })
] }), Zo = ({
  modaltitle: e = "",
  modalopen: r = !1,
  persistent: t = !1,
  togglefullscreen: n = !1,
  className: o = "",
  children: i = /* @__PURE__ */ s.jsx(s.Fragment, {})
}) => {
  const f = ot(), [u, d] = Le(!1), [b, p] = Le(r);
  qe(() => {
    p(r);
  }, [r]), qe(() => {
    var C, U, I, H, F;
    console.log(b, r, t), b && t ? ((C = f.current) == null || C.showModal(), (U = f.current) == null || U.focus()) : b ? ((I = f.current) == null || I.setAttribute("open", "true"), (H = f.current) == null || H.focus()) : (F = f.current) == null || F.close();
  }, [b]);
  const _ = (C) => {
    C.target.title == "close" && p(!1);
  }, j = "wb-modal " + o + (u ? " wb-modal--fullscreen " : "");
  return /* @__PURE__ */ s.jsxs(
    "dialog",
    {
      ref: f,
      "aria-labelledby": e,
      className: j,
      role: "dialog",
      "aria-modal": "true",
      tabIndex: -1,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "wb-modal__header", children: [
          /* @__PURE__ */ s.jsx("h2", { id: "wb-modal__header__title", className: "wb-modal__header__title", children: e }),
          n && /* @__PURE__ */ s.jsx("button", { className: "wb-modal__header__label material-icons", title: "toggle Fullscreen", onClick: (C) => d(!u), type: "button", children: u ? "fullscreen_exit" : "fullscreen" }),
          /* @__PURE__ */ s.jsx("button", { className: "wb-modal__header__label material-icons", title: "close", onClick: _, "aria-label": "Close", type: "button", children: " close" })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "wb-modal__body", children: i })
      ]
    }
  );
}, Xo = ({
  theme: e = "info",
  classname: r = "",
  icon: t = "",
  active: n = 0,
  close: o = !1,
  inline: i = !1,
  children: f = /* @__PURE__ */ s.jsx(s.Fragment, {})
}) => {
  const [u, d] = Le(n), b = () => {
    d(-1);
  }, p = e ? ` wb-notification--${e} ` : "", _ = i ? " wb-notification--inline " : "", j = "wb-notification " + r + " " + p + " " + _;
  if (u == null ? d(-1) : isNaN(u) && d(0), t == "" && e == "info" ? t = "info" : t == "" && e == "warning" ? t = "warning" : t == "" && e == "success" ? t = "check_circle" : t == "" && (e == "danger" || e == "error") && (t = "error"), u && u > 0) {
    var C = u * 1e3;
    setTimeout(function() {
      b();
    }, C);
  }
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsxs("div", { className: j, role: "status", "aria-live": "polite", children: [
    t && /* @__PURE__ */ s.jsx("span", { className: "wb-notification__icon material-icons", children: t }),
    /* @__PURE__ */ s.jsx("span", { className: "wb-notification__text", children: u != -1 && f }),
    o && /* @__PURE__ */ s.jsx("button", { onClick: b, className: "wb-notification__close", "aria-label": "Close", children: /* @__PURE__ */ s.jsx("span", { className: "material-icons", children: "close" }) })
  ] }) });
}, Jo = ({
  theme: e = "info",
  classname: r = "",
  trigger: t = "hover",
  position: n = "right",
  content: o = "",
  children: i = ""
}) => {
  const f = `wb-tooltip wb-tooltip--${e} ` + r;
  return /* @__PURE__ */ s.jsxs("div", { className: f, "data-trigger": t, "data-position": n, children: [
    /* @__PURE__ */ s.jsx("div", { className: "wb-tooltip--trigger", title: o, children: i }),
    /* @__PURE__ */ s.jsx("div", { className: "wb-tooltip--content", role: "tooltip", children: /* @__PURE__ */ s.jsx("div", { className: "wb-tooltip--content__inner", children: o }) })
  ] });
}, Go = ({
  inverse: e = !1,
  variant: r = "half",
  leftcolumn: t = /* @__PURE__ */ s.jsx(s.Fragment, {}),
  rightcolumn: n = /* @__PURE__ */ s.jsx(s.Fragment, {})
}) => {
  const o = `wb-twocolumns ${e && " wb-twocolumns--inverse"} `;
  return /* @__PURE__ */ s.jsx("div", { className: o, children: /* @__PURE__ */ s.jsxs("div", { className: `wb-container wb-twocolumns__container  ${r}`, children: [
    /* @__PURE__ */ s.jsx("div", { className: "wb-twocolumns__left", children: t }),
    /* @__PURE__ */ s.jsx("div", { className: "wb-twocolumns__right", children: n })
  ] }) });
};
export {
  Fo as W,
  Wo as a,
  Ho as b,
  Vo as c,
  Yo as d,
  zo as e,
  Bo as f,
  dn as g,
  qo as h,
  Ko as i,
  Zo as j,
  Xo as k,
  Jo as l,
  Go as m,
  fa as p,
  Ze as u
};
